import { createEvent } from "./create-event";

export type PageViewEvent = {
  page_path: string;
  page_location: string;
  page_referrer: string;
  page_title: string;
  user_id: string | number | null;
  is_logged: boolean;
  user_ordered_visits: number;
  selected_city: string | null;
  selected_address: string | null;
  geo_ip_city: string | null;
  zone_id: number | null;
  cart_id: number | null;
  customer_type: string;
};

// Odsłona strony (SPA) ze wspólnym payloadem kontekstu użytkownika (logowanie, miasto, koszyk, strefa).
export const pageViewEvent = createEvent<PageViewEvent>("page_view");
